import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../utility";
const initialState = {
  categoryName: null,
  // categoryType: "latest",
  categoryType: "pt1",
  categoryTypeList: [],
  leadsexhausted: false,
  lastDoc: null,
  limit: 8,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.UPDATE_CATEGORYNAME:
      return updateObject(state, action.payload);
    case actionTypes.UPDATE_CATEGORYTYPE:
      return updateObject(state, action.payload);
    case actionTypes.CATEGORY_PRODUCTS_CONTROLS:
      return updateObject(state, action.payload);
    default:
      return state;
  }
};

export default reducer;
